import Fetcher from "./FetchService";
// Private static variables
const baseUrl = "/aviso/achievement/";
export default class AchievementService {
    static getTemplatePreview(template, achievementTypeId, sentAsSystem) {
        return Fetcher.getSingleResponse(baseUrl + "getTemplatePreview", {
            template,
            achievementTypeId,
            sentAsSystem,
        });
    }
}
